import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../../ui/Tooltip'
import BellOnIcon from '../../ui/KpiCard/icons/BellOnIcon'
import ClockIcon from '../../ui/icons/ClockIcon'
import CircleCheckIcon from '../../ui/icons/CircleCheckIcon'
import ExclamationCircleIcon from '../../ui/icons/ExclamationCircleIcon'
import { categoryLabelForCount } from '../IssueStatuses/constants'
import StatusProgressRow from './StatusProgressRow'

export const DONE_TOOLTIP = 'Inclut les alertes non exploitables.'

const iconForCategory = category => {
  if (category === 'in_progress')
    return ClockIcon
  if (category === 'done')
    return CircleCheckIcon
  return BellOnIcon
}

const CARD_CLASS = 'tw:flex tw:flex-col tw:gap-4 tw:p-4 tw:bg-white tw:border tw:border-solid '
  + 'tw:border-gray-300 tw:rounded-lg tw:h-full'
const ICON_BOX_CLASS = 'tw:flex tw:items-center tw:justify-center tw:size-12 tw:rounded-lg '
  + 'tw:bg-gray-100 tw:shrink-0 tw:text-gray-600'
const RATE_TAG_CLASS = 'tw:inline-flex tw:items-center tw:text-xs tw:font-medium tw:rounded! '
  + 'tw:bg-green-100 tw:text-green-800 tw:px-2 tw:py-0.5'

const formatRate = (total, grandTotal) => {
  const percent = Math.round(total / grandTotal * 10000) / 100
  return String(percent).replace('.', ',')
}

const CategorySummaryCard = ({ category, label, total, statuses, grandTotal }) => {
  const Icon = iconForCategory(category)
  const displayLabel = total > 1 ? categoryLabelForCount(category, total) : label
  const alertNoun = total > 1 ? 'alertes' : 'alerte'
  const resolutionRate = category === 'done' && grandTotal > 0 ? formatRate(total, grandTotal) : null
  return (
    <div className={CARD_CLASS}>
      <div className="tw:flex tw:items-center tw:gap-3">
        <div className={ICON_BOX_CLASS}>
          <Icon className="tw:size-6" />
        </div>
        <div className="tw:flex tw:flex-col tw:gap-1 tw:min-w-0">
          <div className="tw:flex tw:items-center tw:gap-1 tw:text-sm tw:leading-tight tw:text-gray-500">
            <span>{displayLabel}</span>
            {category === 'done' ? (
              <Tooltip content={DONE_TOOLTIP}>
                <ExclamationCircleIcon className="tw:size-2.5" />
              </Tooltip>
            ) : null}
          </div>
          <div className="tw:flex tw:items-end tw:gap-1">
            <span className="tw:text-xl tw:font-bold tw:leading-tight tw:text-gray-900">{total}</span>
            <span className="tw:text-xs tw:leading-tight tw:text-gray-500">{alertNoun}</span>
            {resolutionRate === null ? null : <span className={RATE_TAG_CLASS}>{`${resolutionRate} %`}</span>}
          </div>
        </div>
      </div>
      <div className="tw:flex tw:flex-col tw:gap-1">
        {statuses.map(status => (
          <StatusProgressRow
            key={status.id}
            color={status.color}
            count={status.count}
            name={status.name}
            total={total}
          />
        ))}
      </div>
    </div>
  )
}

CategorySummaryCard.propTypes = {
  category: PropTypes.string,
  grandTotal: PropTypes.number,
  label: PropTypes.string,
  statuses: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    count: PropTypes.number,
    id: PropTypes.number,
    name: PropTypes.string
  })),
  total: PropTypes.number
}

CategorySummaryCard.defaultProps = {
  category: null,
  grandTotal: 0,
  label: '',
  statuses: [],
  total: 0
}

export default CategorySummaryCard
